import React, { useEffect } from "react";
import { Box, Dialog, DialogContent, DialogTitle, Button } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { getUserLicenseList } from "../../redux/actions/license.action";
import ButtonLoader from "../../components/shared/ButtonLoader";
import parse from "html-react-parser";

type Props = {
  open: boolean;
  onClose: any;
}

const UserLicenseDialog = (props: Props) => {
  const { open, onClose } = props;
  const dispatch = useDispatch();

  const { list, total, isLoading } = useSelector(({ licenseReducer }) => licenseReducer);

  useEffect(() => {
    dispatch(getUserLicenseList());
  }, [dispatch]);

  return (
    <Dialog open={open} onClose={(event, reason) => {
      if (reason === "backdropClick" || reason === "escapeKeyDown") {
        return;
      }
      onClose();
    }}>
      <DialogTitle>
        {/* Terms of Service */}
      </DialogTitle>
      <DialogContent>
        {
          !isLoading && !!total &&
          list
            .filter((item: any) => item.active == true)
            .map((license: any) => (
              <Box key={license.ID}>
                {parse(license.content)}
              </Box>
            ))
        }
        <Button
          variant="contained"
          className="bg-primary font-bold tracking-widest float-right mt-4"
          onClick={onClose}
          disabled={isLoading}
        >
          {isLoading ? <ButtonLoader /> : "I Agree"}
        </Button>
      </DialogContent>
    </Dialog>
  );
};

export default UserLicenseDialog;